


































































import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import RoleCreateDialog from '@/components/permissions/RoleCreateDialog.vue';
import RoleDeleteButton from '@/components/permissions/RoleDeleteButton.vue';
import { Permission } from '@/modules/backend/Entities/Permission';
import { EditPermissionData } from '@/modules/backend/Dto/EditPermissionData';
import { Role } from '@/modules/backend/Entities/Role';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';

const PermissionsModule = namespace('dashboard/permissions');
const RolesModule = namespace('dashboard/roles');

@Component({
  mixins: [Mixin],
  components: {
    'role-create-dialog': RoleCreateDialog,
    'role-delete-button': RoleDeleteButton,
    'data-table-wrapper': DataTableWrapper
  }
})
export default class Permissions extends Mixins(Mixin) {
  /*  P E R M I S S I O N S  */
  @PermissionsModule.Getter('Permissions')
  private readonly Permissions!: Permission[];

  @PermissionsModule.Action('List')
  private ListPermissions!: () => Promise<void>;

  @PermissionsModule.Action('Update')
  private UpdatePermission!: (payload: EditPermissionData) => Promise<void>;

  /*  R O L E S  */
  @RolesModule.Getter('Roles')
  private readonly Roles!: Role[];

  @RolesModule.Action('List')
  private ListRoles!: () => Promise<void[]>;

  private loading = false;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id'
      },
      {
        text: this.$i18n.t('screens.permissions.table.headers.action').toString(),
        value: 'permission',
        sortable: false
      },
      ...this.Roles.map((item): DataTableHeader & {roleId: number; persist: boolean} => ({
        text: item.getTitle(),
        sortable: false,
        value: 'roles',
        align: 'center',
        roleId: item.getId(),
        class: 'roles-table-title',
        persist: item.isPersistence,
      }))
    ];
  }

  private get Rules(): { PermissionId: number; Roles: number[] }[] {
    return this.Permissions.map((permission): { PermissionId: number; Roles: number[] } => {
      return {
        PermissionId: permission.getId(),
        Roles: this.Roles.filter((role: Role): boolean => {
          return permission.getRoles().some((item) => item.getId() === role.getId());
        })
          .map((item: Role): number => item.getId())
      };
    });
  }

  private async savePermission(item: Permission, newName: string): Promise<void> {
    if (!item) {
      return;
    }

    await this.UpdatePermission({
      id: item.getId(),
      name: newName
    });
  }

  private async checkboxChange(roleIds: number[], permission: Permission): Promise<void> {
    const TIMEOUT = 300;

    try {
      const begin = window.performance.now();
      this.loading = true;
      await this.UpdatePermission({
        id: permission.getId(),
        roleIds
      });
      const end = window.performance.now();
      await new Promise((resolve) => setTimeout(resolve, TIMEOUT - (end - begin)));
    } finally {
      this.loading = false;
    }
  }

  public async mounted(): Promise<void> {
    this.loading = true;
    await Promise.all([
      this.ListPermissions(),
      this.ListRoles()
    ]);
    this.loading = false;
  }
}
